module.exports = __webpack_public_path__ + "static/media/af129207-70ba-4641-9700-bb78e8e9273f.7a2c07bd.JPG";